var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('calendarTitle'),_c('calendarColor'),_c('calendarButtonText'),(_vm.checkData())?_c('saveBtn',{staticClass:"saveBtn",attrs:{"callback":function() { _vm.setSave(); }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }